import React from "react";

export const Team = (props) => {
  const team = props.data || [];
  const rollingTeam = team.length ? [...team, ...team] : [];

  return (
    <section id="team" className="team-section">
      <div className="container team-shell">
        <div className="team-heading">
          <h2>Meet the Team</h2>
          <p>
            Discover the researchers, builders, and advisors driving CradleAI
            forward
          </p>
        </div>

        <div className="team-marquee" aria-label="CradleAI team members">
          <div className="team-track">
            {rollingTeam.map((member, index) => (
              <article className="team-card" key={`${member.name}-${index}`}>
                <img src={member.img} alt={member.name} />
                <div>
                  <h3>{member.name}</h3>
                  <p>{member.job}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
